import { deleteReq, getReq, patchReq, postReq, putReq, UploadReq } from "../utils/request";
import { EntityParentType, Task, TaskSearchCriteria, TaskStatus } from "../types/Task";

export const searchTasks = async (criteria: TaskSearchCriteria) => {
    // `message` is the non-200 body — callers toast it on failure.
    return await postReq<{ data: Task[]; total: number; message?: string }>("tasks/search", criteria);
};

// Deliberately untyped: callers probe `response.body?.data ?? response.body`,
// so a strict `Task` body type cannot compile against them unchanged.
export const getTaskById = async (taskId: number) => {
    return await getReq(`tasks/${taskId}`);
};

export const getTasksByParent = async (parentType: EntityParentType, parentId: number) => {
    return await getReq<Task[]>(`tasks/by-parent/${parentType}/${parentId}`);
};

export const createTask = async (task: Partial<Task> | FormData) => {
    return await postReq("tasks", task);
};

export const updateTask = async (taskId: number, task: Partial<Task> | FormData) => {
    return await putReq(`tasks/${taskId}`, task);
};

export const deleteTask = async (taskId: number) => {
    return await deleteReq(`tasks/${taskId}`);
};

export const updateTaskStatus = async (taskId: number, status: TaskStatus, completeSubtasks?: boolean) => {
    return await patchReq(`tasks/${taskId}/status`, { status, completeSubtasks });
};

export interface TaskReorderBody {
    status?: TaskStatus;
    parentTaskId?: number | null;
    prevTaskId?: number | null;
    nextTaskId?: number | null;
    sortOrder?: number;
    completeSubtasks?: boolean;
}

export const reorderTask = async (taskId: number, body: TaskReorderBody) => {
    return await patchReq(`tasks/${taskId}/reorder`, body);
};

export const uploadTaskDocument = async (taskId: number, file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    return await UploadReq(`tasks/${taskId}/documents/upload`, formData);
};
